class API {
  constructor() {
    this.url =
      "https://script.google.com/macros/s/AKfycbwCrrRQy4PV9rLWel7C7kUtGFRitiYFlqEXIB1oL8vU1urxif219pwh_QaSFRVvfKCMdw/exec";
  }

  async push(feedbackData) {
    const data = JSON.stringify(feedbackData);

    return fetch(this.url, {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: data,
    });
  }
}

export default API;
